module.exports = __webpack_public_path__ + "img/engagement_9.7ec5d892.jpg";